export default function AttainImages() {
    return (
        <div className='flex flex-col justify-center items-center gap-5 md:gap-9 mt-[48px] md:mt-[98px]'>
            <img src='https://ik.imagekit.io/bpfumapog/attain1.png?tr=f-auto,q-80' alt='attain1' className='max-w-[390px] md:max-w-[996px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/attain2.png?tr=f-auto,q-80' alt='attain2' className='max-w-[390px] md:max-w-[996px]'/>
            <img src='https://ik.imagekit.io/bpfumapog/attain3.png?tr=f-auto,q-80' alt='attain3' className='max-w-[390px] md:max-w-[996px]'/>
        </div>
    )

}
